// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-border[data-v-2163dc47] {\n  border-left: 4px solid #aab7b1;\n}", ""]);
// Exports
module.exports = exports;
